// components/ToastContainer.js
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const Toast = () => {
  return <ToastContainer />
}

export default Toast
